import React, { useEffect, useState } from 'react'
import AddEditRecordPage from './AddEditViewRecord.page'
import { fetchHybridLayoutForService, LayoutResponseType } from '@app-store'
import { HybridLayoutIntakeWrapper } from '../components/hybird-layout/HybridLayoutIntakeWrapper'
import { getTypeOfLayoutByModeForService } from '../utils/form.utils'
import { AddEditRecordWrapperWithHybridSupportProps } from '../types/layout.types'
import { ENTITY_NAME, LAYOUT_TYPE_NAMESPACE } from '../utils/constants'
import { Loader } from '@ui-kit'

export const AddEditRecordWrapperWithHybridSupport: React.FC<
  AddEditRecordWrapperWithHybridSupportProps
> = ({
  mode,
  layoutId,
  allowNavigate = true,
  updateBreadCrumb = true,
  shouldRedirectOnEditWhenSensitive = true,
  onSaveClick,
  onCancel,
  onEditClick,
  entityId,
  showMaxRTE,
  id,
}) => {
  const [hybridLayout, setHybridLayout] = useState<
    LayoutResponseType | undefined
  >(undefined)
  const [isLoader, setIsLoader] = useState<boolean>(false)

  const fetchDataForService = async () => {
    try {
      setIsLoader(true)

      const response = await fetchHybridLayoutForService(
        id ?? '',
        getTypeOfLayoutByModeForService(mode)
      )

      setHybridLayout(response?.data)
    } catch (error) {
      console.log(error)
      setHybridLayout(undefined)
    } finally {
      setIsLoader(false)
    }
  }

  useEffect(() => {
    if (entityId === ENTITY_NAME.CASE_ENTITY_ID && mode && id) {
      fetchDataForService()
    } else {
      setHybridLayout(undefined)
      setIsLoader(false)
    }
  }, [entityId, mode, id])

  if (isLoader) {
    return (
      <div>
        <Loader isGlobal={false} loaderHeight="64" loaderWidth="64" />
      </div>
    )
  }

  return (
    <>
      {hybridLayout?.type === LAYOUT_TYPE_NAMESPACE.CUSTOM_EDIT_MODE ? (
        <HybridLayoutIntakeWrapper
          mode={mode}
          layoutData={hybridLayout}
          recordId={id ?? ''}
          onSaveClick={onSaveClick}
          onCancel={onCancel}
          onEditClick={onEditClick}
          entityId={entityId}
          allowNavigate={allowNavigate}
          id={id}
          shouldRedirectOnEditWhenSensitive={shouldRedirectOnEditWhenSensitive}
          key={`${entityId}-${id}-${mode}`}
          showMaxRTE={showMaxRTE}
        />
      ) : (
        <AddEditRecordPage
          layoutId={layoutId ?? hybridLayout?.id}
          mode={mode}
          id={id}
          entityId={entityId}
          allowNavigate={allowNavigate}
          onSaveClick={onSaveClick}
          onCancel={onCancel}
          onEditClick={onEditClick}
          updateBreadCrumb={updateBreadCrumb}
          shouldRedirectOnEditWhenSensitive={shouldRedirectOnEditWhenSensitive}
          key={`${entityId}-${id}-${mode}`}
          showMaxRTE={showMaxRTE}
        />
      )}
    </>
  )
}
